/* eslint-disable max-len */
import PropTypes from 'prop-types';
import React from 'react';

const PlayVideoIcon = props => (
  <svg viewBox='0 0 18 18' xmlns='http://www.w3.org/2000/svg' style={ props.style }>
    <circle cx='9' cy='9' r='9' fill='white' />
    <path
      d='M6.91233 4.70651C6.57907 4.5064 6.15494 4.74645 6.15494 5.13517V12.8594C6.15494 13.248 6.57882 13.4881 6.91209 13.2882L13.3481 9.42859C13.6718 9.23447 13.672 8.76542 13.3484 8.57112L6.91233 4.70651Z'
      fill='#111111'
    />
  </svg>
);

PlayVideoIcon.propTypes = {
  style: PropTypes.object
};

export default PlayVideoIcon;
